import { render } from "./order_summary_table.vue?vue&type=template&id=20ffb856&scoped=true"
import script from "./order_summary_table.vue?vue&type=script&lang=ts"
export * from "./order_summary_table.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-20ffb856"

export default script